/** @typedef {import('./types').MailItemSnapshot} MailItemSnapshot */

/** @type {MailItemSnapshot} */
const DEFAULT_SNAPSHOT = {
  isCompose: false,
  from: { emailAddress: "sender@example.com", displayName: "Jane Sender" },
  to: [{ emailAddress: "user@example.com", displayName: "Test User" }],
  cc: [],
  sender: { displayName: "Jane Sender" },
  subject: "RE: Maintenance request",
  internetMessageId: "<mock-message-id@example.com>",
  inReplyTo: "",
  conversationId: "mock-conversation-id",
  itemType: "message",
  userDisplayName: "Test User",
};

/**
 * Browser-testable VSTO host for ?host=vsto&mock=1 without Outlook or WebView2.
 * @returns {import('./officeJsHost').OutlookHost}
 */
export const createMockVstoHost = () => {
  /** @type {MailItemSnapshot} */
  let snapshot = { ...DEFAULT_SNAPSHOT };

  /** @type {Set<(s: MailItemSnapshot) => void>} */
  const listeners = new Set();

  const notify = () => listeners.forEach((l) => l(snapshot));

  return {
    kind: "vsto",
    bridgeVersion: 1,

    async onReady() {
      await Promise.resolve();
    },

    onItemChanged(handler) {
      listeners.add(handler);
      return () => listeners.delete(handler);
    },

    async waitForItemReady() {
      return snapshot;
    },

    getSnapshot() {
      return snapshot;
    },

    isComposeMode() {
      return !!snapshot.isCompose;
    },

    getUserDisplayName() {
      return snapshot.userDisplayName || "Test User";
    },

    getMessageKey() {
      return snapshot.internetMessageId || snapshot.inReplyTo || "";
    },

    async getSubject() {
      return snapshot.subject || "";
    },

    async setSubject(subject) {
      snapshot = { ...snapshot, subject };
      notify();
    },

    async getBodyText() {
      return "Mock email body for local VSTO UI testing.";
    },

    async getBodyHtml() {
      return "<p>Mock email body for local VSTO UI testing.</p>";
    },

    async getBodyType() {
      return "text";
    },

    async setBody() {
      // no-op in mock
    },

    async getSelectedText() {
      return { data: "" };
    },

    async getRecipients() {
      return {
        to: snapshot.to || [],
        sender: snapshot.from,
        cc: snapshot.cc || [],
      };
    },

    async attachFileFromUrl() {
      console.log("[mockVstoHost] attachFileFromUrl");
    },

    openReplyForm(content) {
      console.log("[mockVstoHost] openReplyForm", content?.substring?.(0, 80));
    },

    openReplyAllForm(content) {
      console.log("[mockVstoHost] openReplyAllForm", content?.substring?.(0, 80));
    },

    async getConversationThread() {
      return [
        {
          subject: snapshot.subject,
          from: { emailAddress: snapshot.from?.emailAddress, displayName: snapshot.from?.displayName },
          toRecipients: snapshot.to,
          body: { content: "Prior message in thread.", contentType: "text" },
          receivedDateTime: new Date().toISOString(),
        },
      ];
    },

    isMessageItem() {
      return true;
    },

    supportsGraph() {
      return false;
    },
  };
};
